export default function orderByPosition(a, b) {
  return (
    (a.position === null) - (b.position === null) ||
    +(a.position > b.position) ||
    -(a.position < b.position)
  );
}
